
import { mapGetters } from "vuex";
import NoDataLabel from "../common/no-data-label.vue";
import menuItemRowWithPriceAndSwitch from "./menu-item-row-with-price-and-switch.vue";
import MenuItemToggleUpdateBtn from "./menu-item-toggle-update-btn.vue";
export default {
  components: {
    menuItemRowWithPriceAndSwitch,
    NoDataLabel,
    MenuItemToggleUpdateBtn
  },
  data() {
    return {
      active: [],
      renderItems: [],
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1]
      },
      requests: [
        {
          id: "in-stock",
          label: " In-Stock item request"
        },
        {
          id: "out-of-stock",
          label: " Out of Stock item request"
        }
      ],
      isDelayed: false
    };
  },
  computed: {
    ...mapGetters("menu", [
      "getSoldOutList",
      "getInStockList",
      "getPendingAvailabilitySyncItems",
      "getEnableDisableItems"
    ]),
    getTotalInstockRequest() {
      return [
        ...this.getEnableDisableItems?.enable?.items,
        ...this.getEnableDisableItems?.enable?.combos,
        ...this.getEnableDisableItems?.enable?.options
      ];
    },
    getTotalOutofstockRequest() {
      return [
        ...this.getEnableDisableItems?.disable?.items,
        ...this.getEnableDisableItems?.disable?.combos,
        ...this.getEnableDisableItems?.disable?.options
      ];
    }
  },
  mounted() {
    let { enable, disable } = this.getEnableDisableItems;
  }
};
